import _concat from "lodash/concat";
import transactions from "./transactions";

export default {
  path: "/transactions",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(transactions)
};
